export default __webpack_public_path__ + "static/media/colusa-beaches.7d356b1a.png";